<!-- loading spinner -->
<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">

  <div *ngFor="let group of form.controls; let i = index">
    <div class="field grid" [formGroupName]="i">
      <label class="col-fixed">
        <input formControlName="Name" class="approval-group-name" placeholder="Approver Group {{i+1}}" pInputText maxlength="20" />  
      </label>
        <div class="col-fixed dropdown-field">
          <p-multiSelect formControlName="SecurityGroupCodes" [options]="securityGroups" optionLabel="Name" defaultLabel="Select..." selectedItemsLabel="{0} items selected">
          </p-multiSelect>
        </div>
        <div *ngIf="group.value.IsDeletionAllowed">
          <span>
            <i class="fa fa-trash-o fa-2x trash fa-icon-btn" aria-hidden="true" (click)="delete(i)"></i>
          </span>
        </div>
    </div>
  </div>

  <div class="field grid">
    <span class="col"><i class="fa fa-plus-square-o fa-2x fa-icon-btn" aria-hidden="true" (click)="addNew()"></i></span>
  </div>

</form>
